import { CSSProperties } from "react";
import { DEFAULT_AVATAR } from "../global/avatars";
import styles from './avatar.module.css';
import { urlAvatar } from "@/src/consts/urls";

type Props = {
    className?: string;
    onClick?: React.MouseEventHandler<HTMLImageElement>;
    src?: string;
    style?: CSSProperties;
    title?: string;
}

export default function PlayerAvatar({
    className,
    onClick,
    src,
    style,
    title,
}: Props): JSX.Element {
    if (!src) {
        src = DEFAULT_AVATAR;
    }

    let classes = className ?? '';
    if (onClick) {
        classes += ' ' + styles.clickable;
    }

    return (
        <picture style={{ display: 'inline-flex' }}>
            <img
                className={classes}
                title={title}
                onClick={onClick}
                src={urlAvatar(src)}
                style={style}
                alt={title}
            />
        </picture>
    );
}
